import { z } from 'zod';

export const UserMetaSchema = z.object({
  username: z
    .string()
    .min(3, { message: 'Username must have at least 3 characters.' })
    .max(20, { message: 'Username cannot exceed 20 characters.' }),
});

export type UserMeta = z.infer<typeof UserMetaSchema>;

export const SignUpSchema = z.object({
  username: UserMetaSchema.shape.username,
  email: z.email({ message: 'Invalid email address.' }),

  password: z
    .string({ message: 'Password is required.' })
    .min(8, { message: 'Password must be at least 8 characters long.' })
    .max(100, { message: 'Password must be at most 100 characters long.' }),
});

export type SignUpSchema = z.infer<typeof SignUpSchema>;

export const SignInSchema = z.object({
  email: z.email({ message: 'Invalid email address.' }),
  password: z
    .string({ message: 'Password is required.' })
    .min(8, { message: 'Password must be at least 8 characters long.' }),
});

export type SignInSchema = z.infer<typeof SignInSchema>;
